import { useState } from 'react';

import Icon from 'components/shared/Icon/Icon';

const InfoBanner = ({ title, description, dismissible = true, onDismiss = null }) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    onDismiss?.(description);
  };

  if (!isVisible) return null;

  return (
    <div className="flex gap-2 rounded-lg border border-solid border-neutral-200 p-3 shadow-sm shadow-neutral-200">
      <Icon icon="info-circle-filled" className="self-start" customColor="#0BA5EC" size={18} />
      <div className="flex flex-col gap-1">
        {title && <span className="text-sm font-500">{title}</span>}
        <p className="text-xs font-400">{description}</p>
      </div>
      {dismissible && (
        <Icon
          icon="close-linear"
          className="cursor-pointer self-start"
          size={18}
          onClick={handleClose}
        />
      )}
    </div>
  );
};

export default InfoBanner;
